{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "DELETE": {
        "TITLE": "Delete Shopify Integration",
        "MESSAGE": "Are you sure you want to delete the Shopify integration?"
      },
      "STORE_URL": {
        "TITLE": "Connect Shopify Store",
        "LABEL": "Store URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Enter your Shopify store's myshopify.com URL",
        "CANCEL": "Annuleren",
        "SUBMIT": "Connect Store"
      },
      "ERROR": "There was an error connecting to Shopify. Please try again or contact support if the issue persists."
    },
    "HEADER": "Integraties",
    "DESCRIPTION": "Het contactcenter integreert met diverse tools en diensten om de efficiëntie van je team te verbeteren. Bekijk de onderstaande lijst om je favoriete apps te configureren.",
    "LEARN_MORE": "Learn more about integrations",
    "LOADING": "Fetching integrations",
    "CAPTAIN": {
      "DISABLED": "Captain is not enabled on your account.",
      "CLICK_HERE_TO_CONFIGURE": "Click here to configure",
      "LOADING_CONSOLE": "Loading Captain Console...",
      "FAILED_TO_LOAD_CONSOLE": "Failed to load Captain Console. Please refresh and try again."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "Subscribed Events",
      "LEARN_MORE": "Learn more about webhooks",
      "FORM": {
        "CANCEL": "Annuleren",
        "DESC": "Webhook events bieden je realtime informatie over wat er gebeurt in je account. Voer een geldige URL in om een callback te configureren.",
        "SUBSCRIPTIONS": {
          "LABEL": "Gebeurtenissen",
          "EVENTS": {
            "INBOX_CREATED": "Inbox aangemaakt",
            "CONVERSATION_CREATED": "Gesprek aangemaakt",
            "CONVERSATION_STATUS_CHANGED": "Gespreksstatus veranderd",
            "CONVERSATION_UPDATED": "Gesprek bijgewerkt",
            "MESSAGE_CREATED": "Bericht aangemaakt",
            "MESSAGE_UPDATED": "Bericht bijgewerkt",
            "WEBWIDGET_TRIGGERED": "Live chat widget geopend door de gebruiker",
            "CONTACT_CREATED": "Contact aangemaakt",
            "CONTACT_UPDATED": "Contact aangemaakt",
            "JARABOT_EVENT": "Interne gebeurtenissen"
          }
        },
        "END_POINT": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Example: {webhookExampleURL}",
          "ERROR": "Voer een geldige URL in"
        },
        "EDIT_SUBMIT": "Webhook bijwerken",
        "ADD_SUBMIT": "Maak webhook"
      },
      "TITLE": "Webhook",
      "CONFIGURE": "Configureren",
      "HEADER": "Webhook instellingen",
      "HEADER_BTN_TXT": "Nieuwe webhook toevoegen",
      "LOADING": "Bijgevoegde webhooks ophalen",
      "SEARCH_404": "Er zijn geen items die overeenkomen met deze zoekopdracht",
      "SIDEBAR_TXT": "<p><b>Webhooks</b> </p> <p>Webhooks zijn HTTP callbacks die voor elk account kunnen worden gedefinieerd. Ze worden geactiveerd door gebeurtenissen zoals het aanmaken van berichten. Je kunt meer dan één webhook aanmaken voor dit account. <br /><br /> Voor het maken van een <b>webhook</b>, klik op de <b>Voeg nieuwe webhook</b> knop toe. U kunt ook alle bestaande webhook verwijderen door te klikken op de verwijderknop.</p>",
      "LIST": {
        "404": "Er zijn geen webhooks geconfigureerd voor dit account.",
        "TITLE": "Webhooks beheren",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Webhook eindpunt",
          "ACTIONS": "Acties"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Bewerken",
        "TITLE": "Webhook bewerken",
        "API": {
          "SUCCESS_MESSAGE": "Webhook configuratie succesvol bijgewerkt",
          "ERROR_MESSAGE": "Kan geen verbinding maken met Woot Server, probeer het later opnieuw"
        }
      },
      "ADD": {
        "CANCEL": "annuleren",
        "TITLE": "Nieuwe webhook toevoegen",
        "API": {
          "SUCCESS_MESSAGE": "Webhook configuratie succesvol toegevoegd",
          "ERROR_MESSAGE": "Kan geen verbinding maken met Woot Server, probeer het later opnieuw"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Verwijderen",
        "API": {
          "SUCCESS_MESSAGE": "Webhook succesvol verwijderd",
          "ERROR_MESSAGE": "Kan geen verbinding maken met Woot Server, probeer het later opnieuw"
        },
        "CONFIRM": {
          "TITLE": "Verwijdering bevestigen",
          "MESSAGE": "Weet je zeker dat je de webhook wilt verwijderen? ({webhookURL})",
          "YES": "Ja, verwijderen ",
          "NO": "Nee, Bewaar het"
        }
      },
      "DISABLED_BADGE": "Uitgeschakeld",
      "DISABLED_REASON": "Automatisch uitgeschakeld na {count} opeenvolgende mislukkingen. Laatste fout: {error}",
      "ENABLE": {
        "BUTTON_TEXT": "Inschakelen",
        "API": {
          "SUCCESS_MESSAGE": "Webhook succesvol ingeschakeld",
          "ERROR_MESSAGE": "Kon webhook niet inschakelen, probeer het later opnieuw"
        }
      }
    },
    "SLACK": {
      "DELETE": "Verwijderen",
      "DELETE_CONFIRMATION": {
        "TITLE": "Integratie verwijderen",
        "MESSAGE": "Weet u zeker dat u de integratie wilt verwijderen? Dit zal leiden tot verlies van toegang tot gesprekken op uw Slack werkruimte."
      },
      "HELP_TEXT": {
        "TITLE": "Using Slack Integration",
        "BODY": "Met deze integratie worden al je inkomende gesprekken gesynchroniseerd met het kanaal ***{selectedChannelName}*** in je Slack-workspace. Je kunt al je klantgesprekken direct in het kanaal beheren en mist nooit een bericht.\n\nDit zijn de belangrijkste functies van de integratie:\n\n**Reageer op gesprekken vanuit Slack:** Om te reageren op een gesprek in het Slack-kanaal ***{selectedChannelName}***, typ je je bericht en verstuur je het als thread. Zo gaat er via het contactcenter een antwoord naar de klant. Zo eenvoudig is het!\n\n **Maak privénotities:** Als je privénotities wilt maken in plaats van antwoorden, begin je bericht dan met ***`note:`***. Zo blijft je bericht privé en ziet de klant het niet.\n\n**Koppel een agentprofiel:** Als de persoon die in Slack heeft geantwoord een agentprofiel in het contactcenter heeft met hetzelfde e-mailadres, worden de antwoorden automatisch aan dat agentprofiel gekoppeld. Zo zie je eenvoudig wie wat wanneer heeft gezegd. Heeft de persoon die antwoordt geen gekoppeld agentprofiel, dan ziet de klant de antwoorden vanuit het botprofiel.",
        "SELECTED": "geselecteerd"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Selecteer een kanaal",
        "UPDATE": "Vernieuwen",
        "BUTTON_TEXT": "Kanaal koppelen",
        "DESCRIPTION": "Je Slack-workspace is nu gekoppeld aan het contactcenter. De integratie is echter nog niet actief. Klik op de onderstaande knop om de integratie te activeren en een kanaal te koppelen.\n\n**Let op:** Als je een privékanaal wilt koppelen, voeg dan eerst onze app toe aan het Slack-kanaal voordat je deze stap uitvoert.",
        "ATTENTION_REQUIRED": "Aandacht vereist",
        "EXPIRED": "Your Slack integration has expired. To continue receiving messages on Slack, please delete the integration and connect your workspace again."
      },
      "UPDATE_ERROR": "There was an error updating the integration, please try again",
      "UPDATE_SUCCESS": "Het kanaal is succesvol verbonden",
      "FAILED_TO_FETCH_CHANNELS": "There was an error fetching the channels from Slack, please try again"
    },
    "OPEN_AI": {
      "AI_ASSIST": "AI Assistent",
      "WITH_AI": " {option} met AI ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Antwoord suggestie",
        "SUMMARIZE": "Samenvatten",
        "REPHRASE": "Verbeter schrijven",
        "FIX_SPELLING_GRAMMAR": "Repareer spelling en grammatica",
        "SHORTEN": "Verkorten",
        "EXPAND": "Uitklappen",
        "MAKE_FRIENDLY": "Wijzig berichttoon naar vriendelijk",
        "MAKE_FORMAL": "Gebruik formele toon",
        "SIMPLIFY": "Vereenvoudigen",
        "TRANSLATE": "Vertalen",
        "TRANSLATE_TO_MAJORITY_LANGUAGE": "Vertalen naar de meerderheidstaal"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Concept inhoud",
        "GENERATED_TITLE": "Gegenereerde inhoud",
        "AI_WRITING": "AI schrijft",
        "BUTTONS": {
          "APPLY": "Deze suggestie gebruiken",
          "CANCEL": "Annuleren"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Integreer met OpenAI",
        "DESC": "Breng geavanceerde AI-functies naar je dashboard met de GPT-modellen van OpenAI. Voer om te beginnen de API-sleutel van je OpenAI-account in.",
        "KEY_PLACEHOLDER": "Voer je OpenAI API-sleutel in",
        "BUTTONS": {
          "NEED_HELP": "Hulp nodig?",
          "DISMISS": "Negeer",
          "FINISH": "Installatie voltooien"
        },
        "DISMISS_MESSAGE": "U kunt OpenAI integratie later instellen wanneer u wilt.",
        "SUCCESS_MESSAGE": "OpenAI integratie installatie succesvol"
      },
      "TITLE": "Verbeter met AI",
      "SUMMARY_TITLE": "Samenvatting met AI",
      "REPLY_TITLE": "Antwoord suggesties met AI",
      "SUBTITLE": "Er wordt een verbeterd antwoord gegenereerd met AI, gebaseerd op je huidige concept.",
      "TONE": {
        "TITLE": "Toon",
        "OPTIONS": {
          "PROFESSIONAL": "Professioneel",
          "FRIENDLY": "Vriendelijk"
        }
      },
      "BUTTONS": {
        "GENERATE": "Genereer",
        "GENERATING": "Genereren...",
        "CANCEL": "Annuleren"
      },
      "GENERATE_ERROR": "There was an error processing the content, please try again"
    },
    "DELETE": {
      "BUTTON_TEXT": "Verwijderen",
      "API": {
        "SUCCESS_MESSAGE": "Integratie succesvol verwijderd"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Verbinden"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Dashboard apps",
      "HEADER_BTN_TXT": "Voeg een nieuwe dashboard app toe",
      "SIDEBAR_TXT": "<p><b>Dashboard-apps</b></p><p>Met dashboard-apps kunnen organisaties een applicatie in het dashboard insluiten om klantenservicemedewerkers context te bieden. Met deze functie kun je zelfstandig een applicatie maken en die in het dashboard insluiten om gebruikersinformatie, bestellingen of eerdere betalingsgeschiedenis te tonen.</p><p>Wanneer je je applicatie in het dashboard insluit, krijgt je applicatie de context van het gesprek en het contact als een window-event. Implementeer een listener voor het message-event op je pagina om de context te ontvangen.</p><p>Klik op de knop 'Een nieuwe dashboard-app toevoegen' om een nieuwe dashboard-app toe te voegen.</p>",
      "DESCRIPTION": "Dashboard Apps allow organizations to embed an application inside the dashboard to provide the context for customer support agents. This feature allows you to create an application independently and embed that to provide user information, their orders, or their previous payment history.",
      "LEARN_MORE": "Learn more about Dashboard Apps",
      "LIST": {
        "404": "There are no dashboard apps configured on this account yet",
        "LOADING": "Fetching dashboard apps...",
        "TABLE_HEADER": {
          "NAME": "Naam",
          "ENDPOINT": "Endpoint"
        },
        "EDIT_TOOLTIP": "Bewerk app",
        "DELETE_TOOLTIP": "App verwijderen"
      },
      "FORM": {
        "TITLE_LABEL": "Naam",
        "TITLE_PLACEHOLDER": "Enter a name for your dashboard app",
        "TITLE_ERROR": "A name for the dashboard app is required",
        "URL_LABEL": "Endpoint",
        "URL_PLACEHOLDER": "Enter the endpoint URL where your app is hosted",
        "URL_ERROR": "A valid URL is required"
      },
      "CREATE": {
        "HEADER": "Voeg een nieuwe dashboard app toe",
        "FORM_SUBMIT": "Bevestigen",
        "FORM_CANCEL": "Annuleren",
        "API_SUCCESS": "Dashboard app configured successfully",
        "API_ERROR": "We couldn't create an app. Please try again later"
      },
      "UPDATE": {
        "HEADER": "Edit dashboard app",
        "FORM_SUBMIT": "Vernieuwen",
        "FORM_CANCEL": "Annuleren",
        "API_SUCCESS": "Dashboard app updated successfully",
        "API_ERROR": "We couldn't update the app. Please try again later"
      },
      "DELETE": {
        "CONFIRM_YES": "Ja, verwijderen",
        "CONFIRM_NO": "Nee, behouden",
        "TITLE": "Verwijdering bevestigen",
        "MESSAGE": "Weet u zeker dat u de app - {appName} wilt verwijderen?",
        "API_SUCCESS": "Dashboard app deleted successfully",
        "API_ERROR": "We couldn't delete the app. Please try again later"
      }
    },
    "LINEAR": {
      "ADD_OR_LINK_BUTTON": "Create/Link Linear Issue",
      "LOADING": "Fetching linear issues...",
      "LOADING_ERROR": "There was an error fetching the linear issues, please try again",
      "CREATE": "Aanmaken",
      "LINK": {
        "SEARCH": "Search issues",
        "SELECT": "Select issue",
        "TITLE": "Link",
        "EMPTY_LIST": "No linear issues found",
        "LOADING": "Loading",
        "ERROR": "There was an error fetching the linear issues, please try again",
        "LINK_SUCCESS": "Issue linked successfully",
        "LINK_ERROR": "There was an error linking the issue, please try again",
        "LINK_TITLE": "Conversation (#{conversationId}) with {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Create/link linear issue",
        "DESCRIPTION": "Create Linear issues from conversations, or link existing ones for seamless tracking.",
        "FORM": {
          "TITLE": {
            "LABEL": "Titel",
            "PLACEHOLDER": "Enter title",
            "REQUIRED_ERROR": "Title is required"
          },
          "DESCRIPTION": {
            "LABEL": "Beschrijving",
            "PLACEHOLDER": "Enter description"
          },
          "TEAM": {
            "LABEL": "Team",
            "PLACEHOLDER": "Selecteer team",
            "SEARCH": "Search team",
            "REQUIRED_ERROR": "Team is required"
          },
          "ASSIGNEE": {
            "LABEL": "Assignee",
            "PLACEHOLDER": "Select assignee",
            "SEARCH": "Search assignee"
          },
          "PRIORITY": {
            "LABEL": "Prioriteit",
            "PLACEHOLDER": "Selecteer prioriteit",
            "SEARCH": "Search priority"
          },
          "LABEL": {
            "LABEL": "Label",
            "PLACEHOLDER": "Select label",
            "SEARCH": "Search label"
          },
          "STATUS": {
            "LABEL": "Status",
            "PLACEHOLDER": "Select status",
            "SEARCH": "Search status"
          },
          "PROJECT": {
            "LABEL": "Project",
            "PLACEHOLDER": "Select project",
            "SEARCH": "Search project"
          }
        },
        "CREATE": "Aanmaken",
        "CANCEL": "Annuleren",
        "CREATE_SUCCESS": "Issue created successfully",
        "CREATE_ERROR": "There was an error creating the issue, please try again",
        "LOADING_TEAM_ERROR": "There was an error fetching the teams, please try again",
        "LOADING_TEAM_ENTITIES_ERROR": "There was an error fetching the team entities, please try again"
      },
      "ISSUE": {
        "STATUS": "Status",
        "PRIORITY": "Prioriteit",
        "ASSIGNEE": "Assignee",
        "LABELS": "Labelen",
        "CREATED_AT": "Created at {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Unlink",
        "SUCCESS": "Issue unlinked successfully",
        "ERROR": "There was an error unlinking the issue, please try again"
      },
      "DELETE": {
        "TITLE": "Are you sure you want to delete the integration?",
        "MESSAGE": "Are you sure you want to delete the integration?",
        "CONFIRM": "Ja, verwijderen",
        "CANCEL": "Annuleren"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Captain",
    "HEADER_KNOW_MORE": "Know more",
    "COPILOT": {
      "SEND_MESSAGE": "Verstuur bericht...",
      "EMPTY_MESSAGE": "Er is een fout opgetreden bij het genereren van het antwoord. Probeer het opnieuw.",
      "LOADER": "Captain is thinking",
      "YOU": "Jij",
      "USE": "Use this",
      "RESET": "Reset",
      "SELECT_ASSISTANT": "Select Assistant"
    },
    "PAYWALL": {
      "TITLE": "Upgrade to use Captain AI",
      "AVAILABLE_ON": "Captain is not available on the free plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "UPGRADE_NOW": "Upgrade now",
      "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Captain AI feature is only available in a paid plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "ASK_ADMIN": "Please reach out to your administrator for the upgrade."
    },
    "BANNER": {
      "RESPONSES": "You've used over 80% of your response limit. To continue using Captain AI, please upgrade.",
      "DOCUMENTS": "Document limit reached. Upgrade to continue using Captain AI."
    },
    "FORM": {
      "CANCEL": "Annuleren",
      "CREATE": "Aanmaken",
      "EDIT": "Vernieuwen"
    },
    "ASSISTANTS": {
      "HEADER": "Assistants",
      "ADD_NEW": "Create a new assistant",
      "DELETE": {
        "TITLE": "Are you sure to delete the assistant?",
        "DESCRIPTION": "This action is permanent. Deleting this assistant will remove it from all connected inboxes and permanently erase all generated knowledge.",
        "CONFIRM": "Ja, verwijderen",
        "SUCCESS_MESSAGE": "The assistant has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the assistant, please try again."
      },
      "FORM_DESCRIPTION": "Fill out the details below to name your assistant, describe its purpose, and specify the product it will support.",
      "CREATE": {
        "TITLE": "Create an assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the assistant, please try again."
      },
      "FORM": {
        "NAME": {
          "LABEL": "Assistant Name",
          "PLACEHOLDER": "Enter a name for the assistant",
          "ERROR": "Please provide a name for the assistant"
        },
        "DESCRIPTION": {
          "LABEL": "Assistant Description",
          "PLACEHOLDER": "Describe how and where this assistant will be used",
          "ERROR": "A description is required"
        },
        "PRODUCT_NAME": {
          "LABEL": "Product Name",
          "PLACEHOLDER": "Enter the name of the product this assistant is designed for",
          "ERROR": "The product name is required"
        },
        "FEATURES": {
          "TITLE": "Features",
          "ALLOW_CONVERSATION_FAQS": "Generate FAQs from resolved conversations",
          "ALLOW_MEMORIES": "Capture key details as memories from customer interactions."
        }
      },
      "EDIT": {
        "TITLE": "Update the assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the assistant, please try again."
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Edit Assistant",
        "DELETE_ASSISTANT": "Delete Assistant",
        "VIEW_CONNECTED_INBOXES": "View connected inboxes"
      },
      "EMPTY_STATE": {
        "TITLE": "No assistants available",
        "SUBTITLE": "Create an assistant to provide quick and accurate responses to your users. It can learn from your help articles and past conversations.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Assistant",
          "NOTE": "Captain Assistant engages directly with customers, learns from your help docs and past conversations, and delivers instant, accurate responses. It handles the initial queries, providing quick resolutions before  transferring to an agent when needed."
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Documents",
      "ADD_NEW": "Create a new document",
      "RELATED_RESPONSES": {
        "TITLE": "Related FAQs",
        "DESCRIPTION": "These FAQs are generated directly from the document."
      },
      "FORM_DESCRIPTION": "Enter the URL of the document to add it as a knowledge source and choose the assistant to associate it with.",
      "CREATE": {
        "TITLE": "Add a document",
        "SUCCESS_MESSAGE": "The document has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the document, please try again."
      },
      "FORM": {
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Enter the URL of the document",
          "ERROR": "Please provide a valid URL for the document"
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select the assistant",
          "ERROR": "The assistant field is required"
        }
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the document?",
        "DESCRIPTION": "This action is permanent. Deleting this document will permanently erase all generated knowledge.",
        "CONFIRM": "Ja, verwijderen",
        "SUCCESS_MESSAGE": "The document has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the document, please try again."
      },
      "OPTIONS": {
        "VIEW_RELATED_RESPONSES": "View Related Responses",
        "DELETE_DOCUMENT": "Delete Document"
      },
      "EMPTY_STATE": {
        "TITLE": "No documents available",
        "SUBTITLE": "Documents are used by your assistant to generate FAQs. You can import documents to provide context for your assistant.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Document",
          "NOTE": "A document in Captain serves as a knowledge resource for the assistant. By connecting your help center or guides, Captain can analyze the content and provide accurate responses for customer inquiries."
        }
      }
    },
    "RESPONSES": {
      "HEADER": "FAQs",
      "ADD_NEW": "Create new FAQ",
      "DOCUMENTABLE": {
        "CONVERSATION": "Conversation #{id}"
      },
      "SELECTED": "{count} selected",
      "BULK_APPROVE_BUTTON": "Approve",
      "BULK_DELETE_BUTTON": "Verwijderen",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "FAQs approved successfully",
        "ERROR_MESSAGE": "There was an error approving the FAQs, please try again."
      },
      "BULK_DELETE": {
        "TITLE": "Delete FAQs?",
        "DESCRIPTION": "Are you sure you want to delete the selected FAQs? This action cannot be undone.",
        "CONFIRM": "Yes, delete all",
        "SUCCESS_MESSAGE": "FAQs deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQs, please try again."
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the FAQ?",
        "DESCRIPTION": "",
        "CONFIRM": "Ja, verwijderen",
        "SUCCESS_MESSAGE": "FAQ deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQ, please try again."
      },
      "FILTER": {
        "ASSISTANT": "Assistant: {selected}",
        "STATUS": "Status: {selected}",
        "ALL_ASSISTANTS": "Allemaal"
      },
      "STATUS": {
        "TITLE": "Status",
        "PENDING": "Afwachtend",
        "APPROVED": "Approved",
        "ALL": "Allemaal"
      },
      "FORM_DESCRIPTION": "Add a question and its corresponding answer to the knowledge base and select the assistant it should be associated with.",
      "CREATE": {
        "TITLE": "Add an FAQ",
        "SUCCESS_MESSAGE": "The response has been added successfully.",
        "ERROR_MESSAGE": "An error occurred while adding the response. Please try again."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Question",
          "PLACEHOLDER": "Enter the question here",
          "ERROR": "Please provide a valid question."
        },
        "ANSWER": {
          "LABEL": "Answer",
          "PLACEHOLDER": "Enter the answer here",
          "ERROR": "Please provide a valid answer."
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select an assistant",
          "ERROR": "Please select an assistant."
        }
      },
      "EDIT": {
        "TITLE": "Update the FAQ",
        "SUCCESS_MESSAGE": "The FAQ has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the FAQ, please try again",
        "APPROVE_SUCCESS_MESSAGE": "The FAQ was marked as approved"
      },
      "OPTIONS": {
        "APPROVE": "Mark as approved",
        "EDIT_RESPONSE": "Edit FAQ",
        "DELETE_RESPONSE": "Delete FAQ"
      },
      "EMPTY_STATE": {
        "TITLE": "No FAQs Found",
        "SUBTITLE": "FAQs help your assistant provide quick and accurate answers to questions from your customers. They can be generated automatically from your content or can be added manually.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain FAQs detects common customer questions—whether missing from your knowledge base or frequently asked—and generates relevant FAQs to improve support. You can review each suggestion and decide whether to approve or reject it."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Connected Inboxes",
      "ADD_NEW": "Connect a new inbox",
      "OPTIONS": {
        "DISCONNECT": "Verbinding verbreken"
      },
      "DELETE": {
        "TITLE": "Are you sure to disconnect the inbox?",
        "DESCRIPTION": "",
        "CONFIRM": "Ja, verwijderen",
        "SUCCESS_MESSAGE": "The inbox was successfully disconnected.",
        "ERROR_MESSAGE": "There was an error disconnecting the inbox, please try again."
      },
      "FORM_DESCRIPTION": "Choose an inbox to connect with the assistant.",
      "CREATE": {
        "TITLE": "Connect an Inbox",
        "SUCCESS_MESSAGE": "The inbox was successfully connected.",
        "ERROR_MESSAGE": "An error occurred while connecting the inbox. Please try again."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Postvak In",
          "PLACEHOLDER": "Choose the inbox to deploy the assistant.",
          "ERROR": "An inbox selection is required."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No Connected Inboxes",
        "SUBTITLE": "Connecting an inbox allows the assistant to handle initial questions from your customers before transferring them to you."
      }
    }
  }
}
